/* eslint-disable import/prefer-default-export */
export const handleError = (error: any, toast: any) => {
  if ([401, 404, 500, 502, 504, 0].includes(error?.request?.status)) {
    const toastmsg: any = error?.response?.data?.message ? error?.response?.data?.message : 'Something is wrong. Please try after sometime.';
    toast.current.show({ severity: 'error', summary: 'Error', detail: toastmsg });
  }
};

export const getInitials = (name: any) => {
  const parts = name.split(' ');
  const firstInitial = parts[0][0].toUpperCase();
  const lastInitial = parts[parts.length - 1][0].toUpperCase();
  return firstInitial + lastInitial;
};
